/**
 * @typedef {RenderableProps} _AbContainerItem_Props
 * @property {'header'|'content'|'footer'} place
 * @property {number} zIndex
 */
export function AbContainerItem({ children, place, zIndex }) {
  return (
    <div className={`ab-container-item-${place}`} style={{ zIndex: zIndex || "auto" }}>
      {children}
    </div>
  );
}
